import axios from "axios";

export const setupAxiosInterceptors = (onUnauthenticated: any) => {
    axios.interceptors.response.use(
        function (response) {
            return response;
        },
        async function (error) {
            if (error.response.status === 401 || error.response.status === 403) {
                onUnauthenticated();
                return Promise.resolve();
            }

            return Promise.reject(error);
        },
    );
};
